import { Search as SearchIcon } from '@mui/icons-material';
import { Stack, OutlinedInput } from '@mui/material';
import { useCallback } from 'react';
import { Controller, useForm } from 'react-hook-form';

interface SearchBoxProps {
  onSearch(keyword: string): void;
}
export function SearchBox(props: SearchBoxProps) {
  const { onSearch } = props;
  const { control, handleSubmit } = useForm<{ keyword: string }>({
    defaultValues: { keyword: '' },
    mode: 'onChange',
  });

  const onSubmit = useCallback(
    async (data: { keyword: string }) => {
      onSearch(data.keyword);
    },
    [onSearch]
  );

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Stack direction="row" spacing={1} alignItems="center">
        <SearchIcon sx={{ color: 'primary.main' }} />
        <Controller
          name="keyword"
          control={control}
          render={({ field }) => (
            <OutlinedInput
              {...field}
              placeholder="キーワードで検索"
              color="primary"
              fullWidth
              inputProps={{
                sx: { px: 2, py: 1 },
              }}
              sx={{
                backgroundColor: 'secondary.main',
                borderRadius: '20px',
              }}
            />
          )}
        />
      </Stack>
    </form>
  );
}
